import { IEbiMailTheme } from "dto/Ebi/IEbiOffice";

/** Te same trzy kolory maili EBI (zapis #RRGGBB niezależnie od wielkości liter). */
export const sameMailTheme = (a?: IEbiMailTheme | null, b?: IEbiMailTheme | null): boolean =>
  !!a &&
  !!b &&
  a.Background.toUpperCase() === b.Background.toUpperCase() &&
  a.ButtonColor.toUpperCase() === b.ButtonColor.toUpperCase() &&
  a.FooterBackground.toUpperCase() === b.FooterBackground.toUpperCase();
